import { useLocation } from "react-router-dom";
import en from "@/content/en";
import ar from "@/content/ar";

const DICT = { en, ar };

export const stripLang = (pathname) => pathname.replace(/^\/ar(?=\/|$)/, "") || "/";

export function useLang() {
  const { pathname, search } = useLocation();
  const lang = pathname === "/ar" || pathname.startsWith("/ar/") ? "ar" : "en";
  const base = stripLang(pathname);
  const lp = (path) => (lang === "ar" ? (path === "/" ? "/ar" : `/ar${path}`) : path);
  const switchPath = (lang === "ar" ? base : base === "/" ? "/ar" : `/ar${base}`) + search;
  return { lang, t: DICT[lang], lp, switchPath, base };
}
